<style lang="less" scoped>
@import '../../../../stylesheet/variable.less';
.pay-type-select{
  z-index: 1;
  height: 100vh;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  div{
    background-color: rgba(255,255,255,1);
    font-size: 15px;
    color: #4a4a4a;
  }
  .back-ground{
     height:calc(~"100vh - 396px");
   // height:calc(100vh - 378px);
    background-color: rgba(0,0,0,.5);
  }
  .select-title {
    height: 44px;
    text-align: center;
    line-height: 44px;
    position: relative;
    &:after{
      .setBottomLine();
    }
  }
  .select-main{
    height: 245px;
    overflow: hidden;
    .select-item{
      height: 49px;
      line-height: 40px;
      position: relative;
      display: flex;
      align-items: center;
      &:after{
        .setBottomLine();
      }
      img{
        width: 41px;
        margin: 0 10px 0 13px;
      }
      .pay-type-name{
        color: #a4a4a4;
        font-size: 15px;
      }
      .select-btn{
        width: 22px;
        height: 22px;
        position: absolute;
        right: 15px;
        top: 15px;
      }
    }
  }
  .to-pay-btn{
    height: 49px;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(275deg, #ff396d, #ff7232);
    font-size: 17px;
    opacity: 1;
    line-height: 49px;
  }
}
</style>

<template>
  <div class="pay-type-select">
    <div class="back-ground" @click="toClose"></div>
    <div class="select-title">
      <span>请选择支付方式</span>
    </div>
    <div class="select-main" :style="{overflow: showMoreText?'hidden':'scroll'}">
      <div class="select-item" v-for="method in payMethodsList" >
        <img class="pay-type-icon" :src="method.payIcon" />
        <div class="pay-type-name">{{method.payDisplayName}}</div>
        <img src="../../../../image/preorder/selected.png" v-if="method.payType===selectedPayType" class="select-btn selected">
        <img src="../../../../image/preorder/unselected.png" v-else class="select-btn unselected" @click="setSelect(method.payType)">
      </div>
    </div>
    <div @click="loadMorePayType" v-if="(showMoreText)&&(payMethodsList.length>5)" style="line-height: 35px;height:35px;text-align:center;color:rgb(155,155,155)">更多支付方式...</div>
    <div  v-else style="line-height: 35px;height:35px;text-align:center;color:rgb(155,155,155)"></div>
    <div class="to-pay-btn" @click="toPay">支付￥{{price | price}}</div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import _ from 'underscore'
import qs from 'querystring'
import cookie from '../../../lib/cookie.js'
import { app } from '../../../util/platform'
import CONSTANT_COOKIE from '../../../constant/cookie.js'
import { Toast, MessageBox } from 'mint-ui'
import CONSTANT from '../../../constant/pay.js'
import Appbridge from '@maizuo-fe/jk-appbridge'
import { Base64 } from 'js-base64'
import { getHostName } from '../../../util/function'

export default {
  props: ['price', 'payOrderId', 'activeCode'],
  data() {
    return {
      payMethodsList: [],
      selectedPayType: '',
      showMoreText:true
    }
  },
  methods: {
    ...mapActions([
      'getPayMethodsList',
      'cashPay',
      'checkPayType',
      'getUserOpenId',
    ]),
    setSelect(payType) {
      this.selectedPayType = payType
    },
    loadMorePayType(){
      this.showMoreText=false
    },
    toPay() {
      if (app.isMZFilm()) {
        this.appPay()
        return
      }
      switch (this.selectedPayType) {
        case CONSTANT.PAY_TYPE_ALIPAY_WAP:
          this.aliPayWap()
          break;
        case CONSTANT.PAY_TYPE_WECHAT_WAP:
          this.wechatPayWap()
          break;
        case CONSTANT.PAY_TYPE_UNIONPAY_WAP:
          this.unionPayWap()
          break;
        case CONSTANT.PAY_TYPE_UNION_WAP:
          this.unionWap()
          break;
        case CONSTANT.PAY_TYPE_CCB_PAY:
          // 龙支付
          this.CCBPay()
          break;
        case CONSTANT.PAY_TYPE_WECHAT_PUBLIC:
          this.wechatPublicPay()
          break;
        default:
          break;
      }
    },
    toClose() {
      this.$emit('close-type-select')
    },
    CCBPay() {
      if (!app.isMZFilm()) {
        Toast({
          message: '参与本次活动请下载或打开「卖座电影」APP',
          position: 'bottom',
          duration: 3000,
        })
        return
      }

      const payType = this.selectedPayType
      this.cashPay({
        totalPrice: this.price,
        payType,
        payOrderId: this.payOrderId,
      }).then(data => {
          const option = {
            payType,
            ...data
          }
          const returnUrl = `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${payType}&rd=${+new Date()}`
          Appbridge.listen((data) => {
            data = (typeof data === 'string' ? JSON.parse(data) : data)
            console.log('App 支付成功', data)
            if (data.type === '402' && data.data === '0') {
              return this.$router.replace({
                path: returnUrl
              })
            } else {
              Toast({
                message: '支付失败',
                position: 'bottom',
                duration: 3000
              })
            }
          })
          Appbridge.redirect('to-pay', option).then((data) => {
            data = (typeof data === 'string' ? JSON.parse(data) : data)
            console.log('App 支付成功', data)
            if (data.type === '402' && data.data === '0') {
              return this.$router.replace({
                path: returnUrl
              })
            } else {
              Toast({
                message: '支付失败',
                position: 'bottom',
                duration: 3000
              })
            }
          }).catch(e => {
            Toast({
              message: e.msg || e,
              position: 'bottom',
              duration: 3000
            })
          })
      }).catch( err=> {
        Toast({
          message: err,
          position: 'bottom',
          duration: 3000
        })
      })
    },
    unionPayWap() {//银联手机网关支付
      this.checkPayType({ // 校验支付方式
        payOrderId: this.payOrderId,
        payType: this.selectedPayType,
        activeCode: this.activeCode,
      }).then(() => {
        return this.cashPay({ // 结算
          totalPrice: this.price,
          payType: this.selectedPayType,
          payOrderId: this.payOrderId,
          // 这里的rd参数用以保护orderType参数免被微信支付自动添加的参数所污染
          openId: cookie(CONSTANT_COOKIE.COOKIE_USER_THIRD_OPENID) || ''
        })
      }).then(() => {
        // this.$router.push({
        //   path: `/mz-act/pay/check/${this.payOrderId}?payLogo=${encodeURIComponent(this.payLogo)}&payType=${this.selectedPayType}&activeCode=${this.activeCode}&rd=${+new Date()}`,
        // })
        this.$router.push({
          path: `/activeCheck?payOrderId=${this.payOrderId}&payLogo=${encodeURIComponent(this.payLogo)}&payType=${this.selectedPayType}&activeCode=${this.activeCode}&rd=${+new Date()}`,
        })
      }).catch((err) => {
        Toast({
          message: err,
           duration: 5000
        })
      })
    },
    appPay() {
      let payType = this.selectedPayType
      switch (this.selectedPayType) {//PAY_TYPE_UNION_WAP
        case CONSTANT.PAY_TYPE_UNION_WAP:
          payType = CONSTANT.PAY_TYPE_UNIONPAY_APP
          break;
        case CONSTANT.PAY_TYPE_UNIONPAY_WAP:
          this.unionPayWap()
          return
        case CONSTANT.PAY_TYPE_ALIPAY_WAP:
          payType = CONSTANT.PAY_TYPE_ALIPAY_APP
          break;
        case CONSTANT.PAY_TYPE_WECHAT_PUBLIC:
        case CONSTANT.PAY_TYPE_WECHAT_WAP:
          payType = CONSTANT.PAY_TYPE_WECHAT_APP
          break;
        default:
          break;
      }
      let self = this
      this.cashPay({
        totalPrice: this.price,
        payType: payType,
        payOrderId: this.payOrderId,
        openId: cookie(CONSTANT_COOKIE.COOKIE_USER_THIRD_OPENID) || ''
      }).then(data => {
        const option = {
          payType,
          ...data
        }

        const url = `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${payType}&rd=${+new Date()}`
        
        //const routerUrl = `/activeCallback?payOrderId=${this.payOrderId}&activeCode=${this.activeCode}&payType=${payType}&rd=${+new Date()}`
        Appbridge.listen((data) => {
          data = (typeof data === 'string' ? JSON.parse(data) : data)
          console.log('App 监听成功', data)
          if (data.type === '402' && data.data === '0') {
            // return this.$router.push({
            //   path: routerUrl,
            // })
            window.location.href=url
          } else {

            Toast({
              message: '支付失败',
              position: 'bottom',
              duration: 3000
            })
          }
        }).catch(e => {
          console.log(typeof e ==="string")
          Toast({
            message: typeof e ==="string"?e:e.message,
            position: 'bottom',
            duration: 3000
          })
        })
        Appbridge.redirect('to-pay', option).then((data) => {
          data = (typeof data === 'string' ? JSON.parse(data) : data)
          console.log('App 支付成功', data)
          if (data.type === '402' && data.data === '0') {
            return this.$router.replace({
              path: returnUrl,
            })
          } else {
            Toast({
              message: '支付失败',
              position: 'bottom',
              duration: 3000,
            })
          }
        }).catch(e => {
          Toast({
             message: typeof e ==="string"?e:e.message,
            position: 'bottom',
            duration: 3000,
          })
        })
      }).catch(e => {
        Toast({
          message: typeof e ==="string"?e:e.message,
          position: 'bottom',
          duration: 3000,
        })
      })
    },
    unionWap() {//银联支付
      console.log("是否是卖座电影？",app.isMZFilm())
      if (app.isMZFilm()) {
        console.log("判定为APP内")
          this.appPay()
          return
      }

      const url = `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${this.selectedPayType}&rd=${+new Date()}`
        
      const wapReturnUrl = encodeURIComponent(url)
      this.cashPay({ // 结算
        totalPrice: this.price,
        payType: this.selectedPayType,
        payOrderId: this.payOrderId,
        returnUrl: wapReturnUrl,
      }).then(data=> {
        document.write(data.paySign)
      }).catch((err) => {
        console.log("err",err)
        Toast({
          message: err,
        })
      })
    },
    aliPayWap() {
      const url = `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${this.selectedPayType}&rd=${+new Date()}`
      const wapReturnUrl = encodeURIComponent(url)
      this.cashPay({ // 结算
        totalPrice: this.price,
        payType: this.selectedPayType,
        payOrderId: this.payOrderId,
        returnUrl: wapReturnUrl,
        // 这里的rd参数用以保护orderType参数免被微信支付自动添加的参数所污染
        // openId: cookie(CONSTANT_COOKIE.COOKIE_USER_THIRD_OPENID) || ''
      }).then(data=> {
        var url = Base64.decode(data.paySign)
        window.location.href=url
      }).catch((err) => {
        Toast({
          message: err,
        })
      })
    },
    wechatPayWap() {
      const url = `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${this.selectedPayType}&rd=${+new Date()}`
      const wapReturnUrl = encodeURIComponent(url)
      this.cashPay({ // 结算
        totalPrice: this.price,
        payType: this.selectedPayType,
        payOrderId: this.payOrderId,
        returnUrl: wapReturnUrl,
        // 这里的rd参数用以保护orderType参数免被微信支付自动添加的参数所污染
        // openId: cookie(CONSTANT_COOKIE.COOKIE_USER_THIRD_OPENID) || ''
      }).then(data=> {
        let payUrl = `${Base64.decode(data.paySign)}`
        let orderId = this.payOrderId
        this.$router.push({
              path: "/preorder/" + orderId + "/pay/wechat/2?payUrl=" + encodeURIComponent(payUrl) + `&productType=0&orderType=${this.selectedPayType}&rd=${+new Date()}`
        })
        // window.location.href=Base64.decode(data.paySign)
      }).catch((err) => {
        Toast({
          message: err,
        })
      })
    },
    wechatPublicPay() {
            const url = `${getHostName()}/mz-act/pay/callback/${this.payOrderId}?activeCode=${this.activeCode}&payType=${this.selectedPayType}&rd=${+new Date()}`
      const returnUrl = encodeURIComponent(url)
      this.getUserOpenId().then(data => {
        this.cashPay({
          totalPrice: this.price,
          payType: this.selectedPayType,
          payOrderId: this.payOrderId,
          returnUrl: returnUrl,
          openId: data.openId
        }).then(data=> {
          data.redirect = url
          data.package = data.packageValue
          window.location.href = `${CONSTANT.PREORDER_WEBCHAT_PUBLIC_PAY_URL}?sign=${Base64.encodeURI(qs.stringify(data))}`
        })
      }).catch(err=> {
        if(err.code === 6814008) {
          // 跳转至绑定 openid 页面
          return MessageBox({
            message: '您尚未绑定卖座网微信公众号，请先绑定之后再支付。',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '去绑定',
            cancelButtonText: '取消',
            cancelButtonHighlight: true,
            closeOnClickModal: true,
          }).then(action => {
            if (action === 'confirm') {
              return this.toBindWechatAccount()
            }
          })
        }
        Toast({
          message: err,
        })
      })
    },
    filterPayType(list) {
      if(_.isEmpty(list || [])) {
        return list
      }

      if(app.isWechat()) {
        console.log("微信中打开的")
        const newList = _.filter(list, (v)=> {
          return v.payType === CONSTANT.PAY_TYPE_UNIONPAY_WAP || v.payType === CONSTANT.PAY_TYPE_WECHAT_PUBLIC ||  v.payType ===CONSTANT.PAY_TYPE_UNION_WAP
        })
        return newList
      } else {
        const nl = _.reject(list, (v)=> {
          return v.payType === CONSTANT.PAY_TYPE_WECHAT_APP || v.payType === CONSTANT.PAY_TYPE_WECHAT_PUBLIC
        })
        return nl
      }
      return list
    },
    toBindWechatAccount(url) {
      const toUrl = url || window.location.href
      // const ret = AUTHCONSTANT.AUTH_WECHAT_AUTHORITY_URL + "?url=" + encodeURIComponent(toUrl)
      const ret = `${getHostName()}/mz-auth/connect/wechat/bind?url=${encodeURIComponent(toUrl)}`
      console.log('toBindWechatAccount ret ', ret)
      return window.location.href = ret
    }
  },
  mounted() {
    this.getPayMethodsList({
      payOrderId: this.payOrderId,
      activeCode: this.activeCode,
    }).then(data => {
      const list = this.filterPayType(data.list)
      //const list = this.filterPayType(data)
      this.payMethodsList = list
      this.selectedPayType = list[0].payType
    })

    if(app.isWechat() && _.isEmpty(cookie(CONSTANT_COOKIE.COOKIE_USER_THIRD_OPENID))) {
      this.getUserOpenId()
    }
  },
  computed: {
    ...mapState({
      payLogo: state => state.coupon.activeDetail.payLogo,
    }),
    isInWeChatApp() { // 判断是否是在微信中打开
      if (app.isWechat()) {
        return true
      }
      return false
    },

  }
}
</script>
